@if (fragranceCatalogService.product(); as product){
  <div class="product-catalog">
    <app-gradient class="gradient gradient__left"></app-gradient>
    <app-gradient class="gradient gradient__right"></app-gradient>
    <div class="product-catalog__container-header">
        <a [routerLink]="['/']" class="body-m">{{ 'fragrance-catalogue.home' | translate }}</a>
        <span class="body-m">/</span>
        <a [routerLink]="['/protected/fragrance-catalogue']" class="body-m">Catalogue</a>
        <span class="body-m">/</span>
        <span class="body-m">{{ product.name }}</span>
    </div>
    <div class="product-catalog__container">
      <div class="image-product-mobile-container">
        <img
          class="image-product-mobile"
          [src]="product.images?.[0]?.url"
          [alt]="product.name || 'Product image'"
          loading="lazy"
          (error)="onImageError($event)"/>
        <app-button 
          (click)="openModal()"
          class="full-screen-button"
          icon="fullscreen"
          type="primary-white">
          </app-button>
        <app-button 
          [routerLink]="['/protected/fragrance-catalogue']"
          class="go-back-button"
          icon="arrow_back"
          type="primary-white">
        </app-button>
      </div>
      <div class="product-catalog__container-left">
          <img
          class="image-product"
          [src]="product.images?.[0]?.url" 
          [alt]="product.name || 'Product image'"
          loading="lazy"
          (error)="onImageError($event)"/>
          <app-button 
            (click)="openModal()"
            class="full-screen-button"
            icon="fullscreen"
            type="primary-white">
          </app-button>
          <app-image-fullscreen-modal
            [imageUrl]="product.images?.[0]?.url"
            [isOpen]="isFullScreenModalOpen"
            [close]="closeModal"
          ></app-image-fullscreen-modal>
          <section class="product-info">
            <div class="line"></div>
            <div class="product-section">
              <span class="heading-s">Product description</span>
              <span class="body-m text-dark-alt truncate-text" [innerHTML]="product.shortDescription"></span>
            </div>
            <div class="line"></div>
            <div class="product-section">
              <span class="heading-s">Compatible categories</span>
              <div class="categories-block">
                @for(category of product.categories; track category){
                  <div class="input-chip input-chip-icon">
                    <mat-icon class="icon-s">check</mat-icon>
                    <span class="body-m">{{ category.name }}</span>
                  </div>
                }
              </div>
            </div>
          </section>
      </div>
      <div class="product-catalog__container-right">
        <div class="notes-families-container">
          <span class="heading-m">{{ product.name }}</span>
          <div class="notes-families">
            @for(noteFamily of product.noteFamilies; track noteFamily){
              <div class="input-chip">
                <span class="body-m">{{ noteFamily.name }}</span>
              </div>
            }
          </div>
        </div>
        <section class="notes-families-container">
          <div class="notes-families-container">
            <span class="body-m">Top notes:</span>
            <div class="notes-families">
              @for(note of product.topNotes; track note){
                <div class="input-chip-notes">
                  <span class="body-m">{{ note.name }}</span>
                </div>
              }
            </div>
          </div>
          <div class="notes-families-container">
            <span class="body-m">Heart notes:</span>
            <div class="notes-families">
              @for(note of product.heartNotes; track note){
                <div class="input-chip-notes">
                  <span class="body-m">{{ note.name }}</span>
                </div>
              }
            </div>
          </div>
          <div class="notes-families-container">
            <span class="body-m">Dry notes:</span>
            <div class="notes-families">
              @for(note of product.dryNotes; track note){
                <div class="input-chip-notes">
                  <span class="body-m">{{ note.name }}</span>
                </div>
              }
            </div>
          </div>
        </section>
        <div class="fragrance-proposal-detail-order">
          <div class="fragrance-proposal-detail-price">
            <div class="fragrance-proposal-detail-price-header">
              <span class="body-s subtitle-color">{{ 'fragrance-catalogue.unit-price' | translate : { volumeUnit: accountService.user().volumeUnit } }}</span>
            </div>
            <span class="body-l-bold">{{ product.transactionalPrice.value | defaultCurrency: product.transactionalPrice.currencyCode }}</span>
          </div>
          <div class="fragrance-proposal-detail-quantity">
            <span class="body-s subtitle-color">{{ 'fragrance-catalogue.quantity' | translate }}
              <span class="body-xs subtitle-color">{{'request.request-details.fragrance.qty-min'| translate: { volumeUnit: accountService.user().volumeUnit, minQuantityToOrder } }}</span>
            </span>
            <app-plus-minus-button
              (quantityEmitEvent)="updateQuantity($event)"
              [minQuantity]="product.minimumQuantity ?? minQuantityToOrder"
              [quantity]="quantity">
            </app-plus-minus-button>
          </div>
        </div>
        <div class="fragrance-proposal-detail-actions">
          <app-button
            [size]="'medium'"
            type="secondary"
            text="{{'request.request-details.fragrance.add-sample' | translate}}"></app-button>
          <app-button
            class="add-to-basket"
            [size]="'medium'"
            width="full"
            icon="arrow_forward"
            text="{{'request.request-details.fragrance.add-basket' | translate}}"></app-button>
        </div>
      </div>
    </div>
  </div>
}